<template>
	<div id="app" v-cloak>
		<div class="banner big">
			<img v-if="banner.officialImgName" :src="picurl + 'official/' + banner.officialImgName" alt="">
			<img v-else src="../../../public/images/join_us.png" alt="">
		</div>
		<div class="banner small">
			<img src="../../../public/images/join-small.jpg" alt="">
		</div>
		<div class="content">
			<div class="title">社会招聘</div>
			<div class="card">
				<div class="card-title" :class="show ? 'green' : ''">管培生<div class="icon" @click="show = !show"><i
							:class="show ? 'el-icon-remove' : 'el-icon-circle-plus'"></i></div>
				</div>
				<div class="card-cont" :class="show ? 'block' : 'none'">
					<div>
						<div>
							<div>岗位职责：</div>
							<div>1、参与公司各业务部门轮岗学习，深入了解各模块的工作流程、核心业务及运营逻辑，快速熟悉公司整体业务架构；</div>
							<div>2、协助部门负责人完成日常工作任务，包括数据整理、报告撰写、项目执行等，在实践中积累业务经验与实操能力；</div>
							<div>3、主动发现工作中的问题与优化空间，结合所学知识提出创新性建议，配合团队推进相关改进方案落地；</div>
							<div>4、参与公司组织的专项培训、技能提升课程及管理实践活动，系统学习专业技能与管理方法论，为后续定岗任职夯实基础；</div>
							<div>5、轮岗结束后，根据个人专长、绩效表现及公司岗位需求，定岗至对应核心岗位，承担具体工作职责，独立推进相关业务；</div>
						</div>
						<div>
							<div>任职要求：</div>
							<div>1、学历背景：本科及以上学历，工商管理相关专业优先；</div>
							<div>2、.综合素质：具备优秀的学习能力、逻辑思维能力与沟通表达能力，能够快速适应新环境、新岗位的工作要求；</div>
							<div>3、职业素养：拥有强烈的责任心与进取心，工作积极主动，具备良好的团队协作意识与抗压能力；</div>
							<div>4、发展潜力：对行业发展趋势有一定的关注度与思考，有学生干部经历、实习经历或项目实践经验者优先；</div>
							<div>5、基本要求：认同公司企业文化，愿意从基层岗位做起，接受跨部门轮岗安排，能服从公司的定岗调配；</div>
						</div>
						<div>
							<div>*应聘简历请发送至：1362484884@qq.com（应聘职位请注明期望工作地点）</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-title" :class="show ? 'green' : ''">电商运营<div class="icon" @click="show = !show"><i
							:class="show ? 'el-icon-remove' : 'el-icon-circle-plus'"></i></div>
				</div>
				<div class="card-cont" :class="show ? 'block' : 'none'">
					<div>
						<div>
							<div>岗位职责：</div>
							<div>1、负责维护电商平台和客户关系；</div>
							<div>2、负责优化和提高重点店铺运营能力和销售额；</div>
							<div>3、负责执行与配合相关营销活动，店铺的促销活动方案策划、上报与执行；</div>
							<div>4、负责收集市场和行业信息，实时监控、分析总结竞争对手、产品等信息，提供有效应对方案。</div>
						</div>
						<div>
							<div>任职要求：</div>
							<div>1、具备2年以上电商运营职经验、有分销开发经验者优先</div>
							<div>2、有上进心，爱岗敬业 ，性格温和，有耐心 </div>
							<div>3、有较强团队合作意识。</div>
							<div>4、负责收集市场和行业信息，实时监控、分析总结竞争对手、产品等信息，提供有效应对方案。</div>
						</div>
						<div>
							<div>*应聘简历请发送至：1362484884@qq.com（应聘职位请注明期望工作地点）</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	picurl
} from '../../api/request.js';
import {
	getOfficialImgByType
} from "../../api/goods.js";
export default {
	data() {
		return {
			show: true,
			picurl,
			banner: ''
		}
	},
	methods: {
		getOfficialImgByType() {
			getOfficialImgByType({
				type: 7
			}).then(res => {
				console.log(res);
				this.banner = res[0];
			})
		},
	},
	created() {
		document.getElementById("app").scrollIntoView();
		this.getOfficialImgByType()
	}
}
</script>

<style scoped="scoped">
.block {
	/* height: 410px; */
}

.none {
	height: 0;
	padding: 0 !important;
	margin: 0 !important;
	border-top: 0px solid #fff !important;
}

.height-doing {
	animation: first 0.5s;
}

.height-no {
	animation: myfirst 0.5s;
}

@-webkit-keyframes myfirst {
	0% {
		margin-top: 0;
	}

	100% {
		margin-top: 0px;
	}
}

@-webkit-keyframes myfirst {
	0% {
		margin-top: 0;
	}

	100% {
		margin-top: -40px;
	}
}

.card-cont {
	transition: all 1s;
	font-size: 18px;
	color: #666;
	line-height: 1.8;
	padding-top: 26px;
	border-top: 1px solid #dcdcdc;
	margin-top: 30px;
	overflow: hidden;
}

.icon {
	position: absolute;
	right: 0;
	top: -6px;
	font-size: 32px;
	color: #1CA167;
	cursor: pointer;
}

.card-title {
	font-size: 24px;
	position: relative;
	color: #333;
}

.card {
	border: 1px solid #1CA167;
	position: relative;
	padding: 30px 44px 30px 60px;
	margin-bottom: 30px;
}

.title {
	padding: 100px 0 60px 0;
	font-size: 36px;
	color: #333;
	font-weight: bold;
	text-align: center;
}

.content {
	position: relative;
	width: 1280px;
	left: 50%;
	margin-left: -640px;
	min-height: 200px;
	margin-bottom: 100px;
}

[v-cloak] {
	display: none;
}

.banner {
	width: 100%;
}

.banner img {
	display: block;
	width: 100%;
	height: 100%;
}

/deep/ .green {
	color: #1CA167 !important;
}

.small {
	display: none;
}

@media (max-width: 500px) {
	.small {
		display: block;
	}

	.big {
		display: none;
	}

	.content {
		padding: 0 12px;
		left: 0;
		margin-left: 0;
		width: 100%;
		box-sizing: border-box;
		margin-bottom: 12px;
		min-height: auto;
	}

	.title {
		font-size: 16px;
		padding-top: 16px;
		padding-bottom: 12px;
	}

	.card {
		padding: 12px;
		border-radius: 8px;
	}

	.card-title {
		font-size: 14px;
	}

	.icon {
		font-size: 18px;
		top: -2px;
	}

	.card-cont {
		font-size: 14px;
		padding-top: 12px;
		margin-top: 12px;
	}
}
</style>
